import React, { createContext, useContext, useEffect, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = checking, false = logged out
  const [token, setToken] = useState(() => localStorage.getItem("alk_token") || "");

  useEffect(() => {
    if (!token) {
      setUser(false);
      return;
    }
    axios
      .get(`${API}/auth/me`, { headers: { Authorization: `Bearer ${token}` } })
      .then((r) => setUser(r.data))
      .catch(() => {
        setUser(false);
        setToken("");
        localStorage.removeItem("alk_token");
      });
  }, [token]);

  const login = async (email, password) => {
    const r = await axios.post(`${API}/auth/login`, { email, password });
    const t = r.data.token;
    localStorage.setItem("alk_token", t);
    setToken(t);
    setUser(r.data);
    return r.data;
  };

  const logout = () => {
    localStorage.removeItem("alk_token");
    setToken("");
    setUser(false);
  };

  const authHeaders = () => (token ? { Authorization: `Bearer ${token}` } : {});

  return (
    <AuthContext.Provider value={{ user, token, login, logout, authHeaders }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error("useAuth must be used within AuthProvider");
  return ctx;
};
